import { Component, EventEmitter, Input, Output } from '@angular/core';
import { StepperSteps, StepKey } from '../../core/enums/stepper.enum';
import { FunnelService } from '../../features/users/components/funnel/funnel.service';

@Component({
  selector: 'app-stepper',
  standalone: false,
  templateUrl: './stepper.component.html',
  styleUrl: './stepper.component.scss'
})
export class StepperComponent {

  @Output() stepChanged = new EventEmitter<StepKey>();
  @Input() currentStep!: StepKey;
  brandingId = '';

  constructor(private funnelService: FunnelService) {
    this.brandingId = localStorage.getItem('brandingId') || '';

    this.funnelService.getBrandingStyles(this.brandingId).subscribe((data) => {
      console.log('Branding styles:', data);
    
      document.documentElement.style.setProperty('--background-color', data.BackgroundColor);
      document.documentElement.style.setProperty('--text-color', data.TextColor);
      document.documentElement.style.setProperty('--button-text-color', data.ButtonTextColor);
    
      if (data.ButtonColor.length > 1) {
        document.documentElement.style.setProperty('--button-gradient-start', data.ButtonColor[0]);
        document.documentElement.style.setProperty('--button-gradient-middle', data.ButtonColor[1]);
        document.documentElement.style.setProperty('--button-gradient-end', data.ButtonColor[2]);
      } else {
        document.documentElement.style.setProperty('--button-gradient-start', data.ButtonColor[0]);
        document.documentElement.style.setProperty('--button-gradient-end', data.ButtonColor[0]);
      }
  
    });
  }


  steps = StepperSteps;
  currentStepChange = StepKey.Vehicle;

  goToStep(step: StepKey) {
    console.log('goToStep', step);
    this.currentStepChange = step;
    this.stepChanged.emit(this.currentStepChange);
  }

}
